export default __webpack_public_path__ + "static/blog-search-d314f25c3f6587325d78d61d853cd961.jpg";